import { StackScreenProps } from "@react-navigation/stack";
import { AddGiftCardProductCartRootParamList } from "../../../../types";
import {
  Button,
  Label,
  Page,
  Stack,
  TextField,
  useFlashMessages,
  View,
} from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import React from "react";
import { useLazyQuery } from "@apollo/client";
import { GiftCard } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_GIFT_CARD_BY_CODE } from "../../../../utilities/gift-card/constants";

export interface SearchOrAddGiftCardScreenProps
  extends StackScreenProps<
    AddGiftCardProductCartRootParamList,
    "SearchOrAddGiftCardScreen"
  > {}

export const SearchOrAddGiftCardScreen = ({
  navigation,
}: SearchOrAddGiftCardScreenProps) => {
  const [value, setValue] = React.useState("");

  const { t } = useTranslation("gift_card");
  const flashMessagesContext = useFlashMessages();

  const [q, { loading }] = useLazyQuery<{
    giftCardByCode: GiftCard;
  }>(QUERY_GIFT_CARD_BY_CODE);

  const handleOnSearch = React.useCallback(async (giftCardNumber: string) => {
    return q({
      variables: {
        code: giftCardNumber,
      },
    })
      .then((res) => {
        if (res.error?.graphQLErrors) {
          throw new Error(res.error.graphQLErrors[0].message);
        }
        if (res.data?.giftCardByCode) {
          navigation.navigate("AddGiftCardProductScreen", {
            giftCode: res.data.giftCardByCode,
          });
        }
      })
      .catch((err) => {
        console.log("FINDME, err", err);
        flashMessagesContext.showMessage({
          message: err.message ?? t("common:error"),
          severity: "error",
        });
      });
  }, []);

  const footer = (
    <Stack fill>
      <View flex>
        <Button
          onPress={() => {
            navigation.navigate("GenerateGiftCardCodeScreen");
          }}
          label={t("button.new_gift_card")}
          disabled={loading || !!value}
          //disabled={true}
        ></Button>
      </View>
      <View flex>
        <Button
          onPress={async () => {
            await handleOnSearch(value);
          }}
          label={t("button.find_gift_card")}
          isAction
          disabled={!value || loading}
          //disabled={true}
        ></Button>
      </View>
    </Stack>
  );

  return (
    <Page title={t("title.search_or_add_gift_card")} footer={footer}>
      <View>
        <Label label={t("form.gift_card_number.label")}></Label>
        <TextField
          placeholder={t("form.gift_card_number.placeholder")}
          value={value}
          onChangeText={(v) => setValue(v)}
        />
      </View>
    </Page>
  );
};
